import { render, staticRenderFns } from "./breadlist.vue?vue&type=template&id=54f44c3b"
import script from "./breadlist.vue?vue&type=script&lang=js"
export * from "./breadlist.vue?vue&type=script&lang=js"
import style0 from "./breadlist.vue?vue&type=style&index=0&id=54f44c3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports